import React, { useState, useEffect } from "react";
import { Button, TextField, Grid,Tooltip, IconButton } from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { TextValidator } from "react-material-ui-form-validator";
import designForGstr2bRep from "./Gstr2bRepository.module.css";
import axios from "../../../../axios-order";
import moment from "moment";
import DownloadIcon from "@mui/icons-material/Download";
import DatePicker from './DatePicker';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SettingsIcon from '@mui/icons-material/Settings';
import Modal from "react-bootstrap/Modal";

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const dateFormat = (value) => {
  if (!value) return "";

  const m = moment(value, [
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    "YYYY-MM-DDTHH:mm:ss"
  ], true);

  return m.isValid() ? m.format("DD/MM/YYYY") : "";
};


export default function Gstr2bRepository() {
  const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [toMonthError, setToMonthError] = useState("");
  const [showSuccessOnly, setShowSuccessOnly] = useState(false);
  const history = useHistory();

  //...............For Error Message..........................
  const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
    useState("hidden");
  const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
    useState("none");

  //...........Record From Get Api.................
  const [recordForTable, setRecordForTable] = useState([]);
  const [recordForTableSearch, setRecordForTableSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);

  // ..............this is Auto GSTR Download
  const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState('')
  const [fromToYearDisplay, setFromToYearDisplay] = useState('')
  const [next, setNext] = useState(false)
  const [responseMessage, setResponseMessage] = useState("");

  //   Gstr Status code begin
  const [status, setStatus] = useState(false);
  const [data, setData] = useState([]);
  const [errorMessages, setErrorMessages] = useState('');
  const [showBoxWrapper, setShowBoxWrapper] = useState(false);
  const [responseData, setResponseData] = useState("");
  const [displayResponse, setDisplayResponse] = useState(false);
  const [taskId, setTaskId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  //Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [reportStatusModalOpen, setReportStatusModalOpen] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [reportStatusData, setReportStatusData] = useState([]);
  const [autoDownloadStatusData, setAutoDownloadStatusData] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);




  useEffect(() => {
    // Call the additional API only when taskId is available
    if (taskId) {
      const additionalApiUrl = `/autodownloadapi/${taskId}`;
      axios.get(additionalApiUrl)
        .then(response => {
          console.log('Additional API response:', response.data);
          // Process the additional API response as needed
        })
        .catch(error => {
          console.error('Error calling additional API:', error);
        });
    }
  }, [taskId]);

  const handleButtonClick = () => {
    setShowBoxWrapper(!showBoxWrapper);
  };

  // Update the handleReportStatus function
  const handleReportStatus = (record) => {
    console.log(record);
    setSelectedRecord(record);

    // Fetch auto download status
    axios
      .get(`/get_gstr2b_period_wise_status/${record.id}/${record.org_gstin}`)
      .then((res) => {
        if (res?.data?.status && res?.data?.data) {
          setAutoDownloadStatusData(res.data.data);
        } else {
          setAutoDownloadStatusData(null);
        }
        setReportStatusModalOpen(true);
      })
      .catch((error) => {
        console.log('Error fetching auto download status:', error);
        setAutoDownloadStatusData(null);
        setReportStatusModalOpen(true);
      });
  };

  const fetchReportStatus = (id, org_gstin) => {
    axios
      .get(`/get_gstr2b_period_wise_status/${id}/${org_gstin}`)
      .then((res) => {
        setReportStatusData(res?.data?.records || []);
        console.log('Report status data:', res?.data);
      })
      .catch((error) => {
        console.log('Error fetching report status:', error);
        handleSnackbarOpen('Error fetching report status', 'error');
      });
  };

  const closeReportStatusModal = () => {
    setReportStatusModalOpen(false);
  };

  const isWithinFinancialYear = (fromDate, toDate) => {
    if (!fromDate || !toDate) return true;

    const from = moment(fromDate, 'MMYYYY');
    const to = moment(toDate, 'MMYYYY');

    // Get financial year start (April of the year)
    const fromMonth = from.month(); // 0-11
    const fromYear = from.year();

    let fyStart, fyEnd;

    if (fromMonth >= 3) { // April (3) to March (2)
      fyStart = moment(`04${fromYear}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyStart = moment(`04${fromYear - 1}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    return to.isSameOrAfter(fyStart) && to.isSameOrBefore(fyEnd);
  };

  // Function to open Snackbar
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  // Function to close Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarSeverity("success");
    setResponseMessage("");
  };

  // Add this function to get the date range
  const getToMonthDateRange = () => {
    if (!fromMonthYearDisplay) return {};

    const from = moment(fromMonthYearDisplay, 'MMYYYY');
    const fromMonth = from.month();
    const fromYear = from.year();

    let fyEnd;
    if (fromMonth >= 3) {
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    return {
      minDate: from.toDate(),
      maxDate: fyEnd.clone().endOf('month').toDate()  // <-- only this line changed
    };
  };

  const handleDownload = (gst_task_id, business_entity_id) => {
    const url = `${apiUrl}/gstDownload/gstrtaskdownload/`;
    const requestData = new FormData();
    requestData.append('task_id', gst_task_id);
    requestData.append('entity_id', business_entity_id);

    axios.post(url, requestData)
      .then(response => {
        console.log('API response:', response.data);
        setResponseData(response.data)
        setDisplayResponse(true);
        const autoTaskId = extractAutoTaskId(response.data);
        if (autoTaskId) {
          setTaskId(autoTaskId);
        }

        setTimeout(() => {
          setResponseData('');
          setDisplayResponse(false);
        }, 10000);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  const extractAutoTaskId = (response) => {
    const autoTaskIdPattern = /Auto Task id :(\d+)/;
    const match = response.match(autoTaskIdPattern);
    return match ? match[1] : null;
  };

  const handle = (gst_task_id, business_entity_id) => {
    const url = `${apiUrl}/gstDownload/gstrtaskstatus/`;
    const requestData = new FormData();
    requestData.append('task_id', gst_task_id);
    requestData.append('entity_id', business_entity_id);

    axios.post(url, requestData)
      .then(response => {
        console.log('API response:', response.data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
        if (error.response && error.response.status !== 200) {
          setErrorMessages('An error occurred.');
        }
      });
  };

  const business_entity_id = localStorage.getItem('business_entity_id');

  const handleClick = (first_col, second_col) => {
    axios.post(`${apiUrl}/table/`, { first_col, second_col })
      .then(response => {
        console.log('Data sent to backend:', response.data);
      })
      .catch(error => {
        console.error('Error sending data:', error);
      });
  };

  const handleChange = (event) => {
    setNext(event.target.checked);
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };

const handleToastifyNotification = (res, uploadStatus) => {
    if (uploadStatus === "Failed") {
      handleSnackbarOpen(res, "error");
    } else {
      handleSnackbarOpen(res || "File uploaded successfully", "success");
    }
  };

   const inputHandlerFromPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    const usePassThrough = process.env.REACT_APP_USE_PASSTHROUGH === 'true';

    if (usePassThrough) {
    setFromMonthYearDisplay(formattedDate);
      setFromToYearDisplay('');
    setToMonthError("");
    } else {
    setFromMonthYearDisplay(formattedDate);
    setFromToYearDisplay(formattedDate);
      setToMonthError("");
  }
  };

  // Keep inputHandlerToPicker as is
  const inputHandlerToPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    setFromToYearDisplay(formattedDate);

    // Validate if within financial year
    if (fromMonthYearDisplay && formattedDate) {
      if (!isWithinFinancialYear(fromMonthYearDisplay, formattedDate)) {
        setToMonthError("Please select within the financial year (Apr to Mar)");
      } else {
        setToMonthError("");
      }
    }
  };

  // Add this new function specifically for disabling months
  const shouldDisableMonth = (date) => {
    if (!fromMonthYearDisplay) return false;

    const from = moment(fromMonthYearDisplay, 'MMYYYY');
    const fromMonth = from.month(); // 0-11
    const fromYear = from.year();

    let fyStart, fyEnd;

    if (fromMonth >= 3) { // April (3) to March (2)
      fyStart = moment(`04${fromYear}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyStart = moment(`04${fromYear - 1}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    const checkDate = moment(date);

    // Date must be within financial year AND greater than or equal to from date
    const isWithinFY = checkDate.isBetween(fyStart, fyEnd, 'month', '[]');
    const isAfterOrEqualFrom = checkDate.isSameOrAfter(from, 'month');

    return !(isWithinFY && isAfterOrEqualFrom);
  };

  // Modify the shouldDisableDate function
  const shouldDisableDate = (date) => {
    if (!fromMonthYearDisplay) return false;

    const from = moment(fromMonthYearDisplay, 'MMYYYY');
    const fromMonth = from.month(); // 0-11
    const fromYear = from.year();

    let fyStart, fyEnd;

    if (fromMonth >= 3) { // April (3) to March (2)
      fyStart = moment(`04${fromYear}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear + 1}`, 'MMYYYY');
    } else {
      fyStart = moment(`04${fromYear - 1}`, 'MMYYYY');
      fyEnd = moment(`03${fromYear}`, 'MMYYYY');
    }

    const checkDate = moment(date);

    // Date must be within financial year AND greater than or equal to from date
    const isWithinFY = checkDate.isBetween(fyStart, fyEnd, 'month', '[]');
    const isAfterOrEqualFrom = checkDate.isSameOrAfter(from, 'month');

    return !(isWithinFY && isAfterOrEqualFrom);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
    }, 7000);
    return () => clearTimeout(timer);
  }, [responseMessage]);

  /// This changes for the handleGstr2b 
  const handleGSTR2BDownload = () => {
    setIsSubmitting(true);
 
    const usePassThrough = process.env.REACT_APP_USE_PASSTHROUGH === 'true';
    const entity_id = localStorage.getItem('business_entity_id');
    const gstin = localStorage.getItem('gst');

    if (usePassThrough) {
      axios
        .post(`/get_gstr2b_autodownload_pass_through_response_data`, {
      entity_id: entity_id,
      gstin: gstin,
      fromRetPeriod: fromMonthYearDisplay,
      toRetPeriod: fromToYearDisplay
    })
      .then(response => {
          const responseData = response.data;
          if (responseData.status === false && responseData.message) {
            handleSnackbarOpen(responseData.message, 'error');
          } else if (responseData.status === "success" && responseData.message) {
            handleSnackbarOpen(responseData.message, 'success');
          } else if (responseData.message_type && responseData.message) {
            handleSnackbarOpen(responseData.message, responseData.message_type);
          } else {
            handleSnackbarOpen('An unexpected response was received.', 'error');
          }
        })
        .catch(error => {
          console.log(error);
          handleSnackbarOpen('Unexpected Error.', 'error');
        })
        .finally(() => {
          setIsSubmitting(false);
        });

    } else {
    const formData = new FormData();
    formData.append('entity_id', entity_id);
    formData.append('fromRetPeriod', fromMonthYearDisplay);
      formData.append('toRetPeriod', fromToYearDisplay);
 
      axios
        .post(`${apiUrl}/gstDownload/gstr2bdownload/`, formData)
      .then(response => {
          const responseData = response.data;
          if (responseData.message_type && responseData.message) {
            handleSnackbarOpen(responseData.message, responseData.message_type);
          } else {
            handleSnackbarOpen('An unexpected response was received.', 'error');
          }
      })
      .catch(error => {
        console.log(error);
        handleSnackbarOpen('Unexpected Error.', 'error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
    }
  };
 
  //.............Open And Close Event For Model.............
  const handleOpenAndClose = () => {
    setOpenAndCloseModel(!openAndCloseModel);
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    setFileDataToUpload("");
    setFileName("");
  };

  const fileUploadCancelButtonHandler = () => {
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    setFileDataToUpload("");
    setFileName("");
  };

  //.......Handle Search....................
  const handleSearch = (e) => {
    let Search = e.target.value.trim();
    const searchName = recordForTableSearch.filter((v) => {
      return (
        String(v.gstr_upload_file_type)
          .toLowerCase()
          .indexOf(Search.toLowerCase()) >= 0 ||
        String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
        0 ||
        String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
          Search
        ) >= 0 ||
        String(
          moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY")
        ).indexOf(Search) >= 0
      );
    });
    setRecordForTable(searchName);
  };

  //........For Succesfull Message..................
  const functionForSuccesfullMessageAndErroeMessage = (
    color,
    visible,
    display,
    message
  ) => {
    setColorForErrorMessage(color);
    setErrorMessageVisibilityStyle(visible);
    setErrorMessageDisplayStyle(display);
    setErrorMessage(message);
  };

  //.............File Upload Data Saving in useState..............
  const handleFileUpload = (e) => {
    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    if (e.target.files.length) {
      const file_data = e.target.files[0];
      let fileName = file_data.name;
      setFileName(fileName);
      const reader = new FileReader();
      reader.readAsDataURL(file_data);
      reader.onload = function () {
        let file_value = reader.result;
        setFileDataToUpload(file_value);
      };
      e.target.value = null;
    }
  };

  //......Submit Event For File Upload in axios.......
  const handleSubmitEvent = (e) => {
    // functionForSuccesfullMessageAndErroeMessage(
    //   "green",
    //   "visible",
    //   "block",
    //   "Uploading file Please Wait..."
    // );
    if (fileName === "") {
      functionForSuccesfullMessageAndErroeMessage(
        "red",
        "visible",
        "block",
        "Please Upload The File!"
      );
    } else {
      axios
        .post(`/gstr2b_upload`, {
          file: fileDataToUpload,
          gstin: localStorage.getItem("gst"),
        })
        .then((res) => {
          if (res.data.status === true) {
            // functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
            getApiForGst2bRepository();
            handleSnackbarOpen(res.data.message);
            resetFileUpload();
          } else {
            // functionForSuccesfullMessageAndErroeMessage(
            //   "red",
            //   "visible",
            //   "block",
            //   res.data.Message
            // );
            handleSnackbarOpen(res.data.Message, "error");
            resetFileUpload();
          }
        })
        .catch((error) => {
          functionForSuccesfullMessageAndErroeMessage(
            "red",
            "visible",
            "block",
            error.response.data.Message
          );
          handleSnackbarOpen(error.response.data.Message, "error");
          resetFileUpload();
        });
    }
  };

  const resetFileUpload = () => {
    setFileDataToUpload(null);
    setFileName("");
  };

  //.......................Get Api For Gst................
  const getApiForGst2bRepository = () => {
    setLoaderForTable(true);
    axios
      .post(`/gstr2b_upload_get`, { org_gstin: localStorage.getItem("gst") })
      .then((res) => {
        if (res.data.status === true) {
          setLoaderForTable(false);
          setRecordForTable(res.data.record);
          setRecordForTableSearch(res.data.record);
        } else {
          setLoaderForTable(false);
          alert(res.data.message);
        }
      })
      .catch(() => setLoaderForTable(false));
  };

  const newReconModalClose = () => {
    setFileName("");
    setFromMonthYearDisplay("");
    setFromToYearDisplay("");
    setFileDataToUpload("");
    setErrorMessage("");
  };

  useEffect(() => {
    getApiForGst2bRepository();
  }, []);

  const filteredRecords = recordForTable.filter(
    (v) =>
      !(v.upload_status === "Failed" && v.upload_fail_reason === "Latest Data Already Present")
  );

  return (
    <React.Fragment>
       <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
            <Tooltip title="Back" arrow>
                        <IconButton
                          onClick={handleBackNavigation}
                          sx={{
                            borderRadius: '50%',
                            padding: '6px',
                            color: '#263238',
                            fontSize: '20px',
                            backgroundColor: '#ffffff',
                            height: '36px',
                            width: '36px',
                            '&:hover': {
                              backgroundColor: '#455a64',
                              color: '#ffffff',
                            },
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'background-color 0.3s ease',
                          }}
                        >
                          <ArrowBackIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                      </Tooltip>
            </div>
           <BoxWrapper
                boxTitle={
                  <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "100%",
                    paddingRight: "20px",
                    position: "relative"
                  }}>
                    <span style={{ fontWeight: 600, color: "#000" }}>
                      GSTR-2B Repository
                    </span>
            <span style={{ fontWeight: 600, position: "absolute", left: "45%", transform: "translateX(-50%)" }}>
                      GSTR-2B Auto Download
                    </span>
                  </div>
                }
              >
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            if (fileName && fileDataToUpload) {
              handleSubmitEvent(e);
            } else if (fromMonthYearDisplay && fromToYearDisplay) {
              handleGSTR2BDownload();
            }
          }}
          onError={(errors) => console.log(errors)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '40px' }}>
              {/* Upload Button */}
              <div style={{ minWidth: '100px' }}>
                <label
                  className="button-primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: fromMonthYearDisplay ? "not-allowed" : "pointer",
                    padding: "8px",
                    display: 'block',
                    opacity: fromMonthYearDisplay ? 0.5 : 1,
                    pointerEvents: fromMonthYearDisplay ? 'none' : 'auto'
                  }}
                >
                  Upload
                  <input
                    type="file"
                    accept=".xlsx,.json,.zip"
                    onChange={handleFileUpload}
                    hidden
                    disabled={!!fromMonthYearDisplay}
                  />
                </label>
              </div>
 
              {/* File name field */}
              <div style={{ flex: '0 0 350px' }}>
                <TextField
                  placeholder="Choose file"
                  value={fileName}
                  variant="standard"
                  fullWidth
                  disabled={!!fromMonthYearDisplay}
                  style={{ opacity: fromMonthYearDisplay ? 0.5 : 1 }}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </div>
 
              {/* From Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                  Please Select From Month and Year <span style={{ color: 'red' }}>*</span>:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  placeholder="From Year to Month"
                  format="MM/yyyy"
                  value={fromMonthYearDisplay}
                  onChange={inputHandlerFromPicker}
                  disabled={!!fileName}
                />
              </div>
 
              {/* To Date Picker */}
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <label className={designForGstr2bRep.labelTag}>
                  Please Select To Month and Year *:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  value={fromToYearDisplay}
                  format="MM/yyyy"
                  picker="month"
                  onChange={inputHandlerToPicker}
                  minDate={getToMonthDateRange().minDate}
                  maxDate={getToMonthDateRange().maxDate}
                  className={`${designForGstr2bRep.datePickerTag} ${toMonthError ? designForGstr2bRep.datePickerError : ''}`}
                  placeholder="Select To Month and Year"
                  disabled={
                    !fromMonthYearDisplay ||
                    process.env.REACT_APP_USE_PASSTHROUGH !== 'true' 
                  }
                />
                {toMonthError && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                    {toMonthError}
              </div>
                )}
              </Grid>
 
              {/* Button Group */}
              <div style={{ display: 'flex', gap: '5px', marginLeft: '-25px' }}>
                <div style={{ minWidth: '100px' }}>
                  <Button
                    variant="contained"
                    type="submit"
                    className={designForGstr2bRep.submitButton}
                    disabled={isSubmitting || !!toMonthError}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                </div>
 
                <div style={{ minWidth: '100px' }}>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    onClick={newReconModalClose}
                    style={{ width: '100%', padding: '8px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
        )}
      </BoxWrapper>
 

      {/*..................Table.......................*/}
      <BoxWrapper
        boxTitle="History"
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst2bRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>GSTR2B UPLOAD FILE TYPE</th>
                <th>TAX PERIOD</th>
                <th>FINANCIAL YEAR</th>
                <th>GENERATION DATE</th>
                <th>UPLOAD DATE</th>
                <th>STATUS</th>
                <th>
                  <label>
                    <input
                      type="checkbox"
                      checked={showSuccessOnly}
                      onChange={() => setShowSuccessOnly(!showSuccessOnly)}
                    />
                    Show Success Only
                  </label>
                </th>
                {/* <th>ACTION</th> */}
              </tr>
            </thead>
            <tbody>
              {recordForTable.map((v, index) => {
                let statusText = v.upload_status;
                if (v.upload_status === "Success") {
                  statusText = "Success";
                } else if (v.upload_status === "Initiated") {
                  statusText = "Initiated";
                } else if (v.upload_status === "In Progress") {
                  statusText = "In Progress";
                }

                if (showSuccessOnly && v.upload_status !== "Success") {
                  return null;
                }

                return (
                  <tr key={index}>
                    <td style={{ textTransform: "capitalize" }}>{v.gstr_upload_file_ext}</td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.tax_period !== "None" && v.tax_period ? (
                        v.tax_period.includes(',') ? (
                          // Multiple tax periods
                          v.tax_period.split(',').map((period, idx) => (
                            <span key={idx}>
                              {moment(period.trim(), "MMYYYY").format("MMMM-YYYY")}
                              {idx < v.tax_period.split(',').length - 1 && ', '}
                            </span>
                          ))
                        ) : (
                          // Single tax period
                          moment(v.tax_period, "MMYYYY").format("MMMM-YYYY")
                        )
                      ) : (
                        ""
                      )}
                    </td>
                    <td>{v.financial_year !== "None" ? v.financial_year : ""}</td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.generation_date ? dateFormat(v.generation_date) : ""}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {v.upload_date !== "None" ? dateFormat(v.upload_date) : ""}
                    </td>
                    <td>{statusText}</td>
                  <td>
                      {v.upload_status ? (
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => handleToastifyNotification(v.upload_fail_reason, v.upload_status, v.gstr_upload_file_ext)}
                        >
                          <VisibilityOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{ color: v.upload_status === "Success" ? "#2938c2" : "#b4bfbf" }}
                          />
                        </div>
                      ) : (
                        <VisibilityOutlinedIcon
                          className="action-icon-button showIcon"
                          onClick={() => alert("Data Uploaded")}
                        />
                      )}
                    </td>
                    {/* <td>
                      <SettingsIcon
                        className="action-icon-button showIcon"
                        onClick={v.gstr_upload_file_ext === "Auto Download" ? () => handleReportStatus(v) : null}
                        style={{
                          cursor: v.gstr_upload_file_ext === "Auto Download" ? 'pointer' : 'not-allowed',
                          color: v.gstr_upload_file_ext === "Auto Download" ? '#2938c2' : '#d3d3d3',
                          opacity: v.gstr_upload_file_ext === "Auto Download" ? 1 : 0.5
                        }}
                      />
                    </td> */}

                  </tr>
                );
              })}
              {loaderForTable ? (
                <tr>
                  <td
                    colSpan={7}
                    style={{
                      color: "black",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Loading…Please wait
                  </td>
                </tr>
              ) : recordForTable.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {responseData && (
        <div>
          <p style={{ fontSize: '20px', color: 'green' }}>DOWNLOADED GSTR DATA</p>
          <p>{responseData}</p>
        </div>
      )}

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: '25%' }}
      >
        <MuiAlert
          elevation={2}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}
        </MuiAlert>
      </Snackbar>
      <Modal
        size="lg"
        aria-labelledby="report-status-modal-title"
        centered
        show={reportStatusModalOpen}
        onHide={closeReportStatusModal}
        dialogClassName="modal-lg"
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="report-status-modal-title">
            Auto Download Status Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="responsive-table">
            <table className="custome-table">
              <thead>
                <tr>
                  <th>Period</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {autoDownloadStatusData?.period_wise_status?.length > 0 ? (
                  autoDownloadStatusData.period_wise_status.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.period ? moment(item.period, "MMYYYY").format("MMMM-YYYY") : "-"}
                      </td>
                      <td>{item.status || "-"}</td>
                      <td>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const message = item.message || `Status: ${item.status}`;
                            const severity = item.status === "PASS" ? "success" : "error";
                            handleSnackbarOpen(message, severity);
                          }}
                        >
                          <VisibilityOutlinedIcon
                            className="action-icon-button showIcon"
                            style={{ color: item.status === "PASS" ? "#2938c2" : "#f44336" }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={closeReportStatusModal}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}